import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import lazyModules from './block-imports/modules';
import './block-imports/scripts.js';
import { AlpineAdaptor } from './lazy-blocks/adaptors/AlpineAdaptor';

/**
 * Import all JS from the global folder and all compiled global blocks
 */
import.meta.glob('./global/**/*.js',{ eager: true });
import.meta.glob('../../parts/**/*.js',{ eager: true });

/**
 * Detect if we are in the WordPress block editor (admin).
 * Block previews are rendered asynchronously via ACF server-side rendering,
 * so lazy-loaded Alpine modules won't be available when Alpine processes them.
 *
 * The editor canvas is an iframe whose <body> does not exist yet when this
 * script runs and never carries `wp-admin`, so it is recognised by its frame name.
 */
const isBlockEditor = window.frameElement?.name === 'editor-canvas'
    || document.body?.classList.contains('wp-admin');

if (isBlockEditor) {
    /**
     * In the block editor, eagerly load ALL lazy modules so Alpine has
     * the real component implementations when ACF block previews render.
     * They register themselves on alpine:init, so they must all be loaded
     * before Alpine starts.
     */
    Promise.allSettled(Object.values(lazyModules).map(({ loader }) => loader())).then(() => {
        Alpine.plugin(intersect);
        Alpine.plugin(collapse);
        window.Alpine = Alpine;
        Alpine.start();
    });
} else {
    /**
     * Scan for lazy blocks (pegasus.lazy in block.json) and mark them with x-ignore
     * before Alpine starts, so it doesn't try to initialise components that haven't
     * loaded yet. They are activated once their loading strategy is met.
     */
    const alpineAdaptor = new AlpineAdaptor(Alpine);
    alpineAdaptor.initLazyBlocks(lazyModules);

    Alpine.plugin(intersect);
    Alpine.plugin(collapse);
    window.Alpine = Alpine;
    Alpine.start();

    alpineAdaptor.observeLazyBlocks();
}
